import Icon from 'veui/components/Icon'
import { IconTreasureChest } from 'dls-icons-vue'

Icon.register('treasure-chest', IconTreasureChest)
